import userKind from "~/types/userKind"
export type PictureTarget = "profile_picture" | "banner"
export type PictureSize = "400_400" | "200_200" | "40_40"

export default function ({
  kind,
  target,
  size,
  slug,
}: {
  kind: userKind
  target: PictureTarget
  size: PictureSize
  slug: string | undefined
}) {
  if (slug)
    return `${process.env.IMAGE_BASE_URL}/${kind}/${slug}/${target}/${size}`
  else return `${process.env.IMAGE_BASE_URL}/${kind}/${target}/${size}`
}
